/**
 * btybAuctionService.js — client calls for the Caremap2 city CPM auction.
 * Shaped by: owner request for a BTYB Marketer city auction.
 * Invariants: bids and impression debits go through callables; this module does not write Firestore.
 * Related: functions/src/btybAuction, BtybAuctionPage.jsx, useBtybBanner.js.
 */

import firebase from "firebase/compat/app";
import "firebase/compat/functions";

function callable(name) {
  return firebase.functions().httpsCallable(name);
}

export async function placeBtybBid({ cityKey, message, cpmCents, budgetCents }) {
  const result = await callable("placeBtybBid")({
    cityKey,
    message,
    cpmCents,
    budgetCents,
  });
  return result.data;
}

export async function getBtybCityBoard({ cityKey }) {
  const result = await callable("getBtybCityBoard")({ cityKey });
  return result.data;
}

export async function serveBtybImpression({ cityKey }) {
  const result = await callable("serveBtybImpression")({ cityKey });
  return result.data;
}
